import { sarizIconUrl } from '@bangle.io/ui-components';
import React from 'react';

interface PageHeaderProps {
  title: string;
  illustration?: React.ReactNode;
}

/**
 * Displays a centered header with a title and an optional illustration.
 * Defaults to Typo the cat (typo_main), same brand mark as the sidebar.
 */
export function PageHeader({ title, illustration }: PageHeaderProps) {
  const illustrationContent = illustration ?? (
    <img
      src={sarizIconUrl}
      alt={t.app.common.appLogoAlt}
      className="h-44 w-44 object-contain sm:h-52 sm:w-52"
    />
  );

  return (
    <div className="flex flex-col items-center justify-center gap-4 text-center">
      <div className="mb-2 flex justify-center">{illustrationContent}</div>
      <h2 className="font-semibold text-xl tracking-widest">{title}</h2>
    </div>
  );
}
